import { render, staticRenderFns } from "./StudentCourseCard.vue?vue&type=template&id=55d141c6&scoped=true&"
import script from "./StudentCourseCard.vue?vue&type=script&lang=js&"
export * from "./StudentCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentCourseCard.vue?vue&type=style&index=0&id=55d141c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d141c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VContainer,VDivider,VListItemAvatar})
